import { ModuleStructureObject } from '../../api/interfaces';

export const defaultStructure = {
  root: {
    _type: 'root',
    children: [
      'sec_a1',
      'sec_a2',
      'sec_a3',
      'sec_a4',
      'sec_a5',
      'sec_a6',
      'sec_a7',
      'sec_a8',
      'sec_a9',
    ],
  },

  sec_a1: {
    _type: 'section',
    children: ['sub_a1'],
    customization: {
      title: 'A1 - Qualità Architettonica',
      subTitle: 'Punti max: 14',
      description: '',
      points: 14,
    },
  },
  sub_a1: {
    _type: 'subsection',
    children: ['w_a1a', 'w_a1b'],
    customization: {
      title: 'Qualità Architettonica',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 14,
      concerningArea: 'REQUALIFICATION',
    },
  },
  w_a1a: {
    _type: 'widget',
    _mappedType: 'TextBox',
    customization: {
      description:
        'A1a — Qualità architettonica e paesaggistica del progetto dei manufatti',
      placeHolder:
        'Qualità primarie e secondarie delle strutture e loro collocazione nel contesto di riferimento.',
      defaultValue: '',
      showIfRule: '',
      autocompleteRule: false,
      required: true,
      weight: 9,
    },
  },
  w_a1b: {
    _type: 'widget',
    _mappedType: 'TextBox',
    customization: {
      description: 'A1b — Sistemazione complessiva delle aree scoperte',
      placeHolder:
        'Proposta di naturalizzazione, piantumazione e distribuzione dei percorsi.',
      defaultValue: '',
      showIfRule: '',
      autocompleteRule: false,
      required: true,
      weight: 5,
    },
  },

  sec_a2: {
    _type: 'section',
    children: ['sub_a2'],
    customization: {
      title: 'A2 - Bioedilizia e Architettura Sostenibile',
      subTitle: 'Punti max: 8',
      description: '',
      points: 8,
    },
  },
  sub_a2: {
    _type: 'subsection',
    children: ['w_a2a', 'w_a2b', 'w_a2c'],
    customization: {
      title: 'Bioedilizia e Architettura Sostenibile',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 8,
      concerningArea: 'SUSTAINABILITY_N_ENVIRONMENT',
    },
  },
  w_a2a: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description:
        'A2a — Gestione ecosostenibile della struttura (Recupero Acqua)',
      defaultValue: 'none',
      showIfRule: '',
      options: [
        {
          label: '100% recupero acqua + riduttori flusso + rubinetti a tempo',
          value: 'full',
          valueEqualsDescription: false,
          type: 'string',
          weight: 3,
        },
        {
          label: '>= 50% recupero acqua + riduttori flusso + rubinetti a tempo',
          value: 'partial',
          valueEqualsDescription: false,
          type: 'string',
          weight: 2,
        },
        {
          label: '< 50% recupero acqua o assenza riduttori',
          value: 'none',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },
  w_a2b: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description: 'A2b — Interventi per il risparmio energetico',
      defaultValue: 'none',
      showIfRule: '',
      options: [
        {
          label:
            'FV + Pompe Calore + LED 100% + contenimento 100% + solari-termici 100%',
          value: 'full',
          valueEqualsDescription: false,
          type: 'string',
          weight: 3,
        },
        {
          label:
            'FV + Pompe Calore + LED >= 50% + contenimento >= 50% + solari-termici >= 70%',
          value: 'partial',
          valueEqualsDescription: false,
          type: 'string',
          weight: 2,
        },
        {
          label:
            'Integrazione < 5kW o contenimento < 50% o solari-termici < 70%',
          value: 'none',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },
  w_a2c: {
    _type: 'widget',
    _mappedType: 'TextBox',
    customization: {
      description:
        'A2c — Soluzioni di bioarchitettura e certificazioni ambientali',
      placeHolder:
        'Materiali naturali/riciclabili (CAM), certificazioni LEED, ITACA, ecc.',
      defaultValue: '',
      showIfRule: '',
      autocompleteRule: false,
      required: true,
      weight: 2,
    },
  },

  sec_a3: {
    _type: 'section',
    children: ['sub_a3'],
    customization: {
      title: 'A3 - Accessibilità Disabili',
      subTitle: 'Punti max: 10',
      description: '',
      points: 10,
    },
  },
  sub_a3: {
    _type: 'subsection',
    children: ['w_a3a', 'w_a3b', 'w_a3c', 'w_a3d'],
    customization: {
      title: 'Accessibilità Disabili',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 10,
      concerningArea: 'ACCESSIBILITY_N_QUALITY',
    },
  },
  w_a3a: {
    _type: 'widget',
    _mappedType: 'TextBox',
    customization: {
      description: "A3a — Qualità delle soluzioni per l'accessibilità",
      placeHolder:
        "Progettualità e soluzioni proposte per l'abbattimento delle barriere architettoniche.",
      defaultValue: '',
      showIfRule: '',
      autocompleteRule: false,
      required: true,
      weight: 3,
    },
  },
  w_a3b: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description:
        'A3b — Percentuale ombrelloni attrezzati con piazzola e passerelle (OA)',
      defaultValue: '0',
      showIfRule: '',
      options: [
        {
          label: 'OA = 10%',
          value: '10',
          valueEqualsDescription: false,
          type: 'string',
          weight: 3,
        },
        {
          label: 'OA = 5%',
          value: '5',
          valueEqualsDescription: false,
          type: 'string',
          weight: 2,
        },
        {
          label: 'OA = 0%',
          value: '0',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },
  w_a3c: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description: 'A3c — Numero sedie job / job walker o similari',
      defaultValue: '0',
      showIfRule: '',
      options: [
        {
          label: '2 sedie',
          value: '2',
          valueEqualsDescription: false,
          type: 'string',
          weight: 2,
        },
        {
          label: '1 sedia',
          value: '1',
          valueEqualsDescription: false,
          type: 'string',
          weight: 1,
        },
        {
          label: '0 sedie',
          value: '0',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },
  w_a3d: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description: "A3d — Personale dedicato all'assistenza dei disabili",
      defaultValue: '0',
      showIfRule: '',
      options: [
        {
          label: '2 persone',
          value: '2',
          valueEqualsDescription: false,
          type: 'string',
          weight: 2,
        },
        {
          label: '1 persona',
          value: '1',
          valueEqualsDescription: false,
          type: 'string',
          weight: 1,
        },
        {
          label: '0 persone',
          value: '0',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },

  sec_a4: {
    _type: 'section',
    children: ['sub_a4'],
    customization: {
      title: 'A4 - Capacità Tecnica',
      subTitle: 'Punti max: 6',
      description: '',
      points: 6,
    },
  },
  sub_a4: {
    _type: 'subsection',
    children: ['w_a4a', 'w_a4b'],
    customization: {
      title: 'Capacità Tecnica',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 6,
      concerningArea: 'EXPERIENCE_N_MANAGEMENT',
    },
  },
  w_a4a: {
    _type: 'widget',
    _mappedType: 'ComboBox',
    customization: {
      description: 'A4a — Esperienza gestione diretta ed esclusiva (anni)',
      defaultValue: 'l1',
      showIfRule: '',
      options: [
        {
          label: '>= 12 anni',
          value: '12p',
          valueEqualsDescription: false,
          weight: 4,
        },
        {
          label: '9-12 anni',
          value: '912',
          valueEqualsDescription: false,
          weight: 3.5,
        },
        {
          label: '6-9 anni',
          value: '69',
          valueEqualsDescription: false,
          weight: 3,
        },
        {
          label: '3-6 anni',
          value: '36',
          valueEqualsDescription: false,
          weight: 2.5,
        },
        {
          label: '1-3 anni',
          value: '13',
          valueEqualsDescription: false,
          weight: 2,
        },
        {
          label: '< 1 anno',
          value: 'l1',
          valueEqualsDescription: false,
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },
  w_a4b: {
    _type: 'widget',
    _mappedType: 'ComboBox',
    customization: {
      description: 'A4b — Esperienza gestione art. 45-bis Cod. Nav. (anni)',
      defaultValue: 'l1',
      showIfRule: '',
      options: [
        {
          label: '>= 12 anni',
          value: '12p',
          valueEqualsDescription: false,
          weight: 2,
        },
        {
          label: '9-12 anni',
          value: '912',
          valueEqualsDescription: false,
          weight: 1.75,
        },
        {
          label: '6-9 anni',
          value: '69',
          valueEqualsDescription: false,
          weight: 1.5,
        },
        {
          label: '3-6 anni',
          value: '36',
          valueEqualsDescription: false,
          weight: 1.25,
        },
        {
          label: '1-3 anni',
          value: '13',
          valueEqualsDescription: false,
          weight: 1,
        },
        {
          label: '< 1 anno',
          value: 'l1',
          valueEqualsDescription: false,
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },

  sec_a5: {
    _type: 'section',
    children: ['sub_a5'],
    customization: {
      title: 'A5 - Tipologia di Gestione',
      subTitle: 'Punti max: 6',
      description: '',
      points: 6,
    },
  },
  sub_a5: {
    _type: 'subsection',
    children: ['w_a5a'],
    customization: {
      title: 'Tipologia di Gestione',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 6,
      concerningArea: 'EXPERIENCE_N_MANAGEMENT',
    },
  },
  w_a5a: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description: 'A5a — Impegno alla gestione diretta',
      defaultValue: 'none',
      showIfRule: '',
      options: [
        {
          label: 'Gestione diretta di tutte le attività principali',
          value: 'direct',
          valueEqualsDescription: false,
          type: 'string',
          weight: 6,
        },
        {
          label: 'Gestione principale + art. 45-bis solo per ristorazione',
          value: 'partial',
          valueEqualsDescription: false,
          type: 'string',
          weight: 1,
        },
        {
          label: 'Altro',
          value: 'none',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },

  sec_a6: {
    _type: 'section',
    children: ['sub_a6'],
    customization: {
      title: 'A6 - Filiere Turistiche',
      subTitle: 'Punti max: 5',
      description: '',
      points: 5,
    },
  },
  sub_a6: {
    _type: 'subsection',
    children: ['w_a6a', 'w_a6b'],
    customization: {
      title: 'Filiere Turistiche',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 5,
      concerningArea: 'EXPERIENCE_N_MANAGEMENT',
    },
  },
  w_a6a: {
    _type: 'widget',
    _mappedType: 'TextBox',
    customization: {
      description:
        'A6a — Interazione con componenti turistiche e culturali locali',
      placeHolder:
        "Convenzioni con attività culturali, sportive o commerciali nell'entroterra di Fiumicino.",
      defaultValue: '',
      showIfRule: '',
      autocompleteRule: false,
      required: true,
      weight: 2,
    },
  },
  w_a6b: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description: 'A6b — Adozione di sistemi di prenotazione on-line (App)',
      defaultValue: 'no',
      showIfRule: '',
      options: [
        {
          label: 'Sì',
          value: 'yes',
          valueEqualsDescription: false,
          type: 'string',
          weight: 3,
        },
        {
          label: 'No',
          value: 'no',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },

  sec_a7: {
    _type: 'section',
    children: ['sub_a7'],
    customization: {
      title: 'A7 - Politica Sociale e Servizi',
      subTitle: 'Punti max: 17',
      description: '',
      points: 17,
    },
  },
  sub_a7: {
    _type: 'subsection',
    children: ['w_a7a', 'w_a7b', 'w_a7c', 'w_a7d', 'w_a7e'],
    customization: {
      title: 'Politica Sociale e Servizi',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 17,
      concerningArea: 'EXPERIENCE_N_MANAGEMENT',
    },
  },
  w_a7a: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description: 'A7a — Personale residente nel Comune di Fiumicino (%)',
      defaultValue: 'low',
      showIfRule: '',
      options: [
        {
          label: '>= 60%',
          value: '60',
          valueEqualsDescription: false,
          type: 'string',
          weight: 4,
        },
        {
          label: '30% - 59%',
          value: '3059',
          valueEqualsDescription: false,
          type: 'string',
          weight: 3,
        },
        {
          label: '15% - 29%',
          value: '1529',
          valueEqualsDescription: false,
          type: 'string',
          weight: 1,
        },
        {
          label: '< 14%',
          value: 'low',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },
  w_a7b: {
    _type: 'widget',
    _mappedType: 'TextBox',
    customization: {
      description:
        'A7b — Servizi di sviluppo alla socializzazione territoriale',
      placeHolder:
        'Centri estivi, sport, cultura, convenzioni con Enti/Associazioni per categorie fragili.',
      defaultValue: '',
      showIfRule: '',
      autocompleteRule: false,
      required: true,
      weight: 4,
    },
  },
  w_a7c: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description: 'A7c — Inserimento attività di tipo ricettivo',
      defaultValue: 'no',
      showIfRule: '',
      options: [
        {
          label: 'Sì',
          value: 'yes',
          valueEqualsDescription: false,
          type: 'string',
          weight: 2,
        },
        {
          label: 'No',
          value: 'no',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },
  w_a7d: {
    _type: 'widget',
    _mappedType: 'TextBox',
    customization: {
      description:
        'A7d — Convenzioni con il Comune per difficoltà socio-economiche',
      placeHolder:
        'Servizi in convenzione (es. lettini/ombrelloni/corsi a prezzo calmierato per categorie svantaggiate).',
      defaultValue: '',
      showIfRule: '',
      autocompleteRule: false,
      required: true,
      weight: 5,
    },
  },
  w_a7e: {
    _type: 'widget',
    _mappedType: 'RadioButton',
    customization: {
      description: 'A7e — Ampiezza orario servizi ristorazione / Bar',
      defaultValue: 'low',
      showIfRule: '',
      options: [
        {
          label: 'Apertura Cucina fino alle 23:00',
          value: 'full',
          valueEqualsDescription: false,
          type: 'string',
          weight: 2,
        },
        {
          label: 'Solo servizio Bar fino alle 24:00',
          value: 'bar',
          valueEqualsDescription: false,
          type: 'string',
          weight: 1,
        },
        {
          label: 'Altro',
          value: 'low',
          valueEqualsDescription: false,
          type: 'string',
          weight: 0,
        },
      ],
      autocompleteRule: false,
      required: true,
    },
  },

  sec_a8: {
    _type: 'section',
    children: ['sub_a8'],
    customization: {
      title: 'A8 - Destagionalizzazione',
      subTitle: 'Punti max: 6',
      description: '',
      points: 6,
    },
  },
  sub_a8: {
    _type: 'subsection',
    children: ['w_a8a', 'w_a8b'],
    customization: {
      title: 'Destagionalizzazione',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 6,
      concerningArea: 'EXPERIENCE_N_MANAGEMENT',
    },
  },
  w_a8a: {
    _type: 'widget',
    _mappedType: 'CheckBox',
    customization: {
      description:
        'A8a — Impegno a rimanere aperto nei periodi di chiusura stagionale',
      defaultValue: false,
      showIfRule: '',
      autocompleteRule: false,
      required: false,
      weight: 3,
    },
  },
  w_a8b: {
    _type: 'widget',
    _mappedType: 'TextBox',
    customization: {
      description:
        'A8b — Servizi di socializzazione territoriale nei periodi non balneari',
      placeHolder:
        'Qualità e tipologia dei servizi aggiuntivi proposti fuori stagione.',
      defaultValue: '',
      showIfRule: '',
      autocompleteRule: false,
      required: true,
      weight: 3,
    },
  },

  sec_a9: {
    _type: 'section',
    children: ['sub_a9'],
    customization: {
      title: 'A9 - Certificazioni',
      subTitle: 'Punti max: 6',
      description: '',
      points: 6,
    },
  },
  sub_a9: {
    _type: 'subsection',
    children: ['w_a9a', 'w_a9b', 'w_a9c', 'w_a9d', 'w_a9e'],
    customization: {
      title: 'Certificazioni',
      subTitle: '',
      description: '',
      showIfRule: '',
      points: 6,
      concerningArea: 'SUSTAINABILITY_N_ENVIRONMENT',
    },
  },
  w_a9a: {
    _type: 'widget',
    _mappedType: 'CheckBox',
    customization: {
      description: 'A9a — ISO 13009 (Spiagge attrezzate)',
      defaultValue: false,
      showIfRule: '',
      autocompleteRule: false,
      required: false,
      weight: 2,
    },
  },
  w_a9b: {
    _type: 'widget',
    _mappedType: 'CheckBox',
    customization: {
      description: 'A9b — ISO 9001 / ISO 14001',
      defaultValue: false,
      showIfRule: '',
      autocompleteRule: false,
      required: false,
      weight: 1,
    },
  },
  w_a9c: {
    _type: 'widget',
    _mappedType: 'CheckBox',
    customization: {
      description: 'A9c — ISO 45001 (Salute e Sicurezza sul Lavoro)',
      defaultValue: false,
      showIfRule: '',
      autocompleteRule: false,
      required: false,
      weight: 1,
    },
  },
  w_a9d: {
    _type: 'widget',
    _mappedType: 'CheckBox',
    customization: {
      description: "A9d — SA 8000 (Responsabilità Sociale d'Impresa)",
      defaultValue: false,
      showIfRule: '',
      autocompleteRule: false,
      required: false,
      weight: 1,
    },
  },
  w_a9e: {
    _type: 'widget',
    _mappedType: 'CheckBox',
    customization: {
      description: 'A9e — Certificazione Parità di Genere',
      defaultValue: false,
      showIfRule: '',
      autocompleteRule: false,
      required: false,
      weight: 1,
    },
  },
} as ModuleStructureObject;
